import { fetchTaskTimeTrackingEntries } from './effects';
import { $taskTimeTrackingEntries } from './states';

// Fetch task time tracking entries
$taskTimeTrackingEntries.on(fetchTaskTimeTrackingEntries.doneData, (_, data) => data);
